module.exports = __webpack_public_path__ + "static/img/Composite Insulators.f7b5918.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/Composite Insulators.jpg
// module id = X+94
// module chunks = 1